export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.5 18c0-9.94 8.06-18 18-18s18 8.06 18 18-8.06 18-18 18-18-8.06-18-18zm4 0c0 7.72 6.28 14 14 14s14-6.28 14-14-6.28-14-14-14-14 6.28-14 14zm7.42-2.4l4.58 4.58 8.62-8.58 2.82 2.82-10 10c-.4.38-.9.58-1.42.58-.52 0-1.02-.18-1.42-.58l-6-6 2.82-2.82z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "viewBox": "0 0 36 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};